export const generalConstants = {
    ACTIVE_WORKFLOW : "active_workflow",
    ACTIVE_PHASES : "active_phases",
    ACTIVE_COMPONENT : "active_component",
    NEW_EVENT : "new_event",
    Fill_CLOSURE_FORM :'Fill Closure Form',
    VIEW_SUMMARY :'View Summary',
    ACTIVE_FORM: 'active_form',
    ADD_DETAIL: 'Add Details',
    ACTIVE_PATIENT: 'active_patient',
    FACILITY_BASED: 'FACILITY BASED',
    COMMUNITY_BASED: 'COMMUNITY BASED',
    SEARCH: 'SEARCH',
    TREAT: 'TREAT',
    PREVENT: 'PREVENT'
}